import { Add } from '@mui/icons-material'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { TopBar } from '../../components/general/top-bar/top-bar'
import { navigationLinks } from 'utils/navigation-utils'
import { PageContainer } from 'components/general/containers/PageContainer'
import { StructuresTable } from 'modules/structures/structures/StructuresTable'

export const FormsPage: React.FC = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    return (
        <>
            <TopBar
                rightActions={[
                    <div>
                        <Button
                            startIcon={<Add />}
                            color={'secondary'}
                            variant={'contained'}
                            onClick={() => navigate(navigationLinks.toAddForm())}
                        >
                            {t('addForm', 'Add form')}
                        </Button>
                    </div>,
                ]}
            />
            <PageContainer>
                <StructuresTable />
            </PageContainer>
        </>
    )
}
